import React from "react";

const CaseDetailsSectionLatestMobile = ({
  service,
  lang,
  arPhrase,
  enPhrase,
}) => {
  const {
    id,
    serviceCategory,
    status,
    caseNumber,
    requesterEmail,
    requesterName,
    caseTypeName,
    createdAt,
    contactNumber,
    contactEmail,
    courtName,
    partyTypeName,
    caseYear,
  } = service;
  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center">
        <div className="w-full bg-white flex flex-col md:flex-row flex-wrap gap-[16px] xl:gap-y-[32px] xl:gap-x-[10px] content-between ">
          <div className="flex flex-row  gap-2 items-center min-w-[45%]">
            <p className="text-[14px] font-normal text-[#010202]">
              {lang === "en" ? enPhrase["lblCase"] : arPhrase["lblCase"]}
            </p>
            <p className="max-w-[100px] text-sm font-bold font-Almarai text-[#010202] overflow-hidden text-ellipsis whitespace-nowrap">
              {caseNumber}
            </p>
            <p className="text-[14px]">•</p>
            <p className="text-sm font-bold text-[#010202]">{caseTypeName}</p>
          </div>
          <div className="flex flex-row gap-2 items-center min-w-[45%]">
            <p className="text-[14px] font-normal text-[#737373]">
              {lang === "en" ? enPhrase["lblCourt"] : arPhrase["lblCourt"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{courtName}</p>
          </div>

          <div className="flex flex-row gap-2 items-center min-w-[45%]">
            <p className="text-[14px] font-normal text-[#737373]">
              {lang === "en"
                ? enPhrase["lblCustomerStatus"]
                : arPhrase["lblCustomerStatus"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{partyTypeName}</p>
          </div>

          <div className="flex flex-row  gap-2 items-center min-w-[45%]">
            <p className="text-[14px] font-normal text-[#737373]">
              {lang === "en" ? enPhrase["lblYear"] : arPhrase["lblYear"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{caseYear}</p>
          </div>

          {contactNumber && (
            <div className="flex flex-row  gap-2 items-center min-w-[45%]">
              <p className="text-[14px] font-normal text-[#737373]">
                {lang === "en" ? enPhrase["lblPhone"] : arPhrase["lblPhone"]}
              </p>
              <p
                className={`text-sm font-bold text-[#010202] ${
                  lang === "en" ? "" : "text-right"
                } `}
                dir="ltr"
              >
                {contactNumber}
              </p>
            </div>
          )}

          {contactEmail && (
            <div className="flex flex-row gap-2 min-w-[45%]">
              <p className="text-[14px]  font-normal text-[#737373]">
                {lang === "en" ? enPhrase["lblEmail"] : arPhrase["lblEmail"]}:
              </p>
              <p className="max-w-[150px] text-sm font-bold font-Almarai text-[#010202] overflow-hidden text-ellipsis whitespace-nowrap">
                {contactEmail}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseDetailsSectionLatestMobile;
